export default {
    getActivityOfferedModalities: { method: 'get', url: 'activity_offered_modalities' },
    postActivityOfferedModality: { method: 'post', url: 'activity_offered_modalities' },
    putActivityOfferedModality: { method: 'put', url: 'activity_offered_modalities/{id}' },
    deleteActivityOfferedModality: { method: 'delete', url: 'activity_offered_modalities/{id}' },
}
